import {
  Flex,
  IconButton,
  Skeleton,
  Text,
} from '@chakra-ui/react';
import InsightPicto from '@/insight/components/insightPicto';
import { insightTypeDictionnary } from '@/insight/lib/insightTypeDictionnary';
import { useEffect, useState } from 'react';
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from 'react-icons/md';
import { useLocation } from 'react-router-dom';
import SlidingInsights from './SlidingInsights';
export default function InsightCardList({ lists, onSetAsOutdated }) {
  const [data, setData] = useState();
  const [expandedByType, setExpandedByType] = useState({});
  const location = useLocation();
  const isExpanded = (type) => expandedByType[type] !== false;
  const toggleDisplay = (type) => {
    setExpandedByType((prev) => {
      const next = prev[type] === false;
      localStorage.setItem(type + location.pathname, String(next));
      return { ...prev, [type]: next };
    });
  };
  useEffect(() => {
    if (lists) {
      const newData = Object.entries(insightTypeDictionnary).map(([key, type]) => {
        const list = lists[type];
        if (list && list.length > 0) {
          return {
            type,
            list,
            title: {
              negative: 'Negative Feedback',
              improvement: 'Improvement Feedback',
              positive: 'Positive Feedback',
              behavior: 'Behaviors',
              motivation: 'Motivations'
            }[key]
          };
        }
        return null;
      }).filter(Boolean);
      setData(newData);
      const initialExpanded = {};
      newData.forEach((d) => {
        initialExpanded[d.type] = localStorage.getItem(d.type + location.pathname) !== 'false';
      });
      setExpandedByType(initialExpanded);
    }
  }, [lists, location.pathname]);
  return !data ? (
    <Flex pb={3} w="100%">
      <Skeleton height="50px" w="100%" />
    </Flex>
  ) : (
    <Flex flexDirection="column" width="100%" >
      {data.map((d, i) => (
        <Flex flexDirection="column" w="100%" key={i} gap={2}>
          <Flex
            alignItems="center"
            gap={1}
            px={3}
            cursor="pointer"
            onClick={() => toggleDisplay(d.type)}
          >
            <InsightPicto size={20} type={d.type} />
            <Text>{d.title}</Text>
            <IconButton
              variant="greyTransparent"
              color="text.medium.grey"
              fontSize="16px"
              opacity={1}
              pointerEvents="none"
              tabIndex={-1}
              aria-hidden
              icon={isExpanded(d.type) ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
            />
          </Flex>
          {isExpanded(d.type) && (
            <SlidingInsights
              list={d.list}
              onSetAsOutdated={onSetAsOutdated}
            />
          )}
          {!isExpanded(d.type) && (
            <Flex pb={3}></Flex>
          )}
        </Flex>
      ))}
    </Flex>
  );
}
